// CityListModel
class CityListModel {
    constructor({status = null, timestamp = null, city = []} = {}) {
        this.status = status;
        this.timestamp = timestamp;
        this.city = city.map((item) => City.fromJson(item));
    }

    // Method to convert JSON to CityListModel instance
    static fromJson(json) {
        return new CityListModel({
            status: json.status,
            timestamp: json.timestamp,
            city: json.city,
        });
    }

    // Method to convert CityListModel instance to JSON
    toJson() {
        return {
            status: this.status,
            timestamp: this.timestamp,
            city: this.city.map((item) => item.toJson()),
        };
    }
}

// City Model
class City {
    constructor({id = null, city_name = null} = {}) {
        this.id = id;
        this.cityName = city_name;
    }

    // Method to convert JSON to City instance
    static fromJson(json) {
        return new City({
            id: json.id,
            city_name: json.city_name,
        });
    }

    // Method to convert City instance to JSON
    toJson() {
        return {
            id: this.id,
            city_name: this.cityName,
        };
    }
}

export default CityListModel;
